var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWarningFilled = function SvgWarningFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m15.71 11.97-6-10a2 2 0 0 0-3.43 0l-6 10A2 2 0 0 0 2 15h12a2 2 0 0 0 1.71-3.03ZM8 13a1 1 0 1 1 0-2.001A1 1 0 0 1 8 13Zm1-4a1 1 0 0 1-2 0V5a1 1 0 0 1 2 0v4Z"
  })));
};
export default SvgWarningFilled;